/*
 * FloatingChat Constants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 */

export const LOADER_STATUS = "gtaxpro/FloatingChat/LOADER_STATUS";
export const CHAT_SEND_MESSAGE = "gtaxpro/FloatingChat/CHAT_SEND_MESSAGE";
export const CHAT_RECEIVE_MESSAGE = "gtaxpro/FloatingChat/CHAT_RECEIVE_MESSAGE";
export const CHAT_UPDATE_STREAMING_MESSAGE = "gtaxpro/FloatingChat/CHAT_UPDATE_STREAMING_MESSAGE";
export const CHAT_FINALIZE_STREAMING_MESSAGE = "gtaxpro/FloatingChat/CHAT_FINALIZE_STREAMING_MESSAGE";
export const CHAT_SET_ERROR = "gtaxpro/FloatingChat/CHAT_SET_ERROR";
export const CHAT_CLEAR_ERROR = "gtaxpro/FloatingChat/CHAT_CLEAR_ERROR";
export const CHAT_CLEAR_MESSAGES = "gtaxpro/FloatingChat/CHAT_CLEAR_MESSAGES";
export const CHAT_SET_TYPING = "gtaxpro/FloatingChat/CHAT_SET_TYPING";
export const CHAT_SET_ACTIVE_SESSION = "gtaxpro/FloatingChat/CHAT_SET_ACTIVE_SESSION";